import React from 'react';

// Make hatTarget 'ref="hatTarget"'
// Add '.fill' to all body elements
// Add '.fill--face' to nose

class HeadHOC extends React.Component {
	componentDidMount() {
		this.props.getHatTargetCoords(this.refs.hatTarget);
	}
}

export default class Heads extends HeadHOC {
	render() {
		return (
			<g>
				<circle ref="hatTarget" cx="252.4510956" cy="124.5629578" r="0" />
				<path className="fill fill--black" d="M254.0057983,105.8250732c2.690979-0.0144806,5.4129944,0.1755829,8.1493835,0.5838623
					c24.6368713,3.6759644,42.9733887,23.1970367,46.4758301,46.6557922
					c7.4205933,49.7020416-20.6480103,71.907074-54.625351,71.907074s-61.7118988-22.7582092-54.6253204-71.907074
					c3.3849182-23.4759979,21.8389435-42.9798279,46.4758453-46.6557922
					C248.5925598,106.0006561,251.3145752,105.8105927,254.0057983,105.8250732z" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/TuxedoBird/Heads.js